import { IUserAutocomplete } from 'authOld/types';
import { mapRecordsFromServer } from 'coreOld/mappers';
import { partfinitiClient } from 'coreOld/services';
import { GetManyResponse, IRequestPayload } from 'coreOld/types';
import { getQueryString, objectKeysCamelToSnakeCase } from 'coreOld/utils';

export const getManyAutocomplete = async (
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
): Promise<GetManyResponse<IUserAutocomplete>> => {
  const { data } = await partfinitiClient.get(
    `/admin/user/autocomplete?${getQueryString(objectKeysCamelToSnakeCase(requestPayload))}`,
    signal
  );

  return mapRecordsFromServer<IUserAutocomplete>(data.users, data.total_count);
};
